export class Info_operacion {
    public data ={};
 
    getSharedData(){
       return this.data
    }
 
    updateSharedData(data){
      //Statements 
      this.data=data;
    }
 }